import { FILTERS_LAYOUT_WIDTH } from 'Common/components/FilterByMultiSelect/consts';
export const BREAKPOINTS = [
    0,
    550,
    FILTERS_LAYOUT_WIDTH,
];
export const CONSEQUENCE_TYPES_FILTER_MAX_WIDTH = 1032;
export const DEFAULT_ANCESTRY = 'European';
